// extracted by mini-css-extract-plugin
export default {"actions":"SMLUpgradePromptActions_actions__mlSX4","later":"SMLUpgradePromptActions_later__7WOF-"};